import React from "react";
import Box from "@mui/material/Box";

const SpeedDial = ({ children }) => {
  return (
    <>
      <div style={{ position:"fixed", right: "1rem", bottom: "3rem" }}>
        <Box sx={{ height: 330, transform: "translateZ(0px)", flexGrow: 1 }}>
          {children}
        </Box>
      </div>
    </>
  );
};

export default SpeedDial;
